// src/components/Screen2_CarType.jsx
import React from 'react';
import { useAppContext } from '../context/AppContext';

function Screen2_CarType() {
    const { showScreen } = useAppContext();

    return (
        <div id="screen-2" className="screen screen_padding">
            <h2 className="title_style text-2xl font-semibold text-center mb-8">Select Car Type</h2>

            <div className="space-y-4">
                <button 
                    id="btn-mpv" 
                    className="w-full text-center p-4 bg-blue-500 text-white rounded-lg shadow-lg transform transition hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400 h-24 flex flex-col justify-center"
                    onClick={() => showScreen('screen-4-testdrive')} // <-- UPDATED
                >
                    <span className="block text-xl font-bold">MPV</span>
                </button>

                {/* Other buttons are removed */}
            </div>
        </div>
    );
}

export default Screen2_CarType;